/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// Bootstrap
require('./bootstrap');


import("vue").then(function (vue) {
    window.Vue = vue.default;

    initVueWithSearch();

    if (
        document.getElementsByTagName('profile-image-upload').length ||
        document.getElementsByTagName('user-messages-user-search').length ||
        document.getElementsByTagName('user-tags-select').length ||
        document.getElementsByTagName('profile-image-upload-non-percentage').length ||
        document.getElementsByTagName('article-detail-recommended').length
    ) {
        Vue.component('profile-image-upload', require('./components/ProfileImageUpload.vue').default);
        Vue.component('profile-image-upload-non-percentage', require('./components/ProfileImageUploadNonPercentage.vue').default);
        Vue.component('user-messages-user-search', require('./components/UserMessagesUserSearch.vue').default);
        Vue.component('user-tags-select', require('./components/UserTagsSelect.vue').default);
        Vue.component('article-detail-recommended', require('./components/ArticleDetailRecommended.vue').default);

        const app = new Vue({
            el: '#app'
        });
    }
});

function initVueWithSearch() {
    const searchApp = new Vue({
        components: {
            'search-block': require('./components/Search.vue').default
        },
        el: '#search-modal'
    });
}

function triggerDisplayModalOnSearch() {
    document.getElementById("search-modal").dispatchEvent(new Event("display-modal"));

    $("#login-modal").slideUp();
}

jQuery(function ($) {
    let $body = $("body");
    let $document = $(document);
    let slickInited = false;
    $('img.lazy').lazyload();
    if ($(".sidebar-article-thumbnail.lazy") !== undefined) {
        $(".sidebar-article-thumbnail.lazy").lazyload();
    }


    $(".js-reply").on("click", function () {
        if ($(this).hasClass('js-to-reply')) {
            var value;
            if ($(this).attr('data-comment-id').includes('reply')) {
                value = $(this).attr('data-comment-id').substring(6);
            } else {
                value = $(this).attr('data-comment-id');
            }
            $("#reply_type").attr('data-type','to-reply').val(value);
        } else if ($(this).hasClass('js-to-topic')) {
            $("#reply_type").attr('data-type','to-topic').val(0);
        }
        $('html, body').animate({
            scrollTop: ($("#topic-reply-form").offset().top - 100),
        });
        $("#ckeditor1").focus();
    });

    if ($body.hasClass("profile-show")) {
        var item = $("div.profile-image > .image");
        $(item).css("height", item.width());
    }

    $(".js-search").on("click", function () {
        $(this).find("input").focus();
    });

    $("li.selected-submenuitem").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).closest("ul.children").toggleClass("show");
    });

    $("#main").on("click", ".toggle-comments", function () {
        let $comments = $(this).closest(".comments");
        $comments.find(".show-comments").toggleClass("d-none");
        $comments.find(".comments").toggleClass("d-none");
    });

    function desktopMenuAction() {
        let authorBlock = $(".hover-author .author-block")
        $(".user.toggle-showuserinfo, .toggle-slide-user-info, .hover-author .author-block").hover(function (e) {
            e.stopPropagation();
            authorBlock.css("display", "block");
        }, function () {
            authorBlock.css("display", "none");
        });
    }

    function mobileMenuAction() {
        $(".user.toggle-showuserinfo, .author-block-close").on("click", function (event) {
            $(".profile").toggleClass('menu-opened');
            event.preventDefault();
            $('.author-block').css('display', $('.profile').hasClass('menu-opened') ? 'block' : 'none');
        });
    }

    $(document).ready(function () {

        if (window.matchMedia("(min-width: 768px)").matches) {
            desktopMenuAction();
        }else{
            mobileMenuAction();
        }

        $(".user-badge").hover(function () {
            let icon = $(this).data('icon');
            $('.badge-desc[data-hover="' + icon + '"]').css('display', 'block');
        }, function () {
            $('.badge-desc').css('display', 'none');
        });

    });

    $(".toggle-expanded-menu").on("click", function () {
        $(this).find("#nav-icon1").toggleClass("open");
        $("#expanded-menu").slideToggle(300, function () {
          if ($(this).is(":visible")) {
            document.body.classList.add("modal-open");
          } else {
            document.body.classList.remove("modal-open");
          }
        });
        $("#login-modal").slideUp();
        $("#search-modal").slideUp();
        //document.body.classList.remove("modal-open");
    });

    $(window).on("resize", function () {
      if ($(window).width() > 991) {
        // Assuming "lg" breakpoint starts at 992px
        $("#expanded-menu").hide();
        $("#nav-icon1").removeClass("open");
        document.body.classList.remove("modal-open");
      }
    });

    $(".toggle-expanded-menu-forum").on("click", function () {
      $("#expanded-menu-forum").slideToggle(300);
      document.body.classList.remove("modal-open");
    });

    $(".category-list-toggle").on("click", function () {
        $("#sidemenu-cat-mobile").slideToggle(300);
    });


    $('#area').on('select2:select', function () {
        $(this).parents('form').submit();
    });

    $("#expanded-menu .section").on("click", function () {
        $(this).toggleClass("open", 300);
    });

    $("body").on("click", ".js-open-login-modal", function (e) {
        e.preventDefault();
        $("#expanded-menu").hide();
        $("#search-modal").slideUp();
        $("#request-login").hide();
        $("#login-modal").slideToggle();
        $body.find("#nav-icon1").removeClass('open');

        // $body.toggleClass("modal-open");

        if (!slickInited) {
            $('.slick').slick({
                autoplaySpeed: 3000,
                dots: true
            });
            slickInited = true;
        }
    });

    $("#login-modal .terms").on("click", function (e) {
        e.preventDefault();
        $("#terms").removeClass("d-none");
        $("#reasons").addClass("d-none");
    });

    $(".js-load-more-home-articles").on("click", function () {
        var $this = $(this);
        $.ajax({
            method: 'post',
            url: '/ladda-fler-start'
        }).then(function (response) {
            $this.replaceWith(response)
            checkCompact();
            $('img.lazy').lazyload();
        })
    });

    $(".js-close-login-modal").on("click", function (e) {
        e.preventDefault();
        $("#login-modal").slideUp();
        $body.removeClass("modal-open");
    });

    $(".js-open-search-modal").on("click", function (e) {
        e.preventDefault();
        $("#login-modal").slideUp();
        $("#expanded-menu").slideUp(300);
        $(".nav-icon1").removeClass('open');
        $("input[name='search']").val("");
        triggerDisplayModalOnSearch();
    });

    $(".search-form-modal input").on("keyup", function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            $(".js-open-search-modal").click();
            $("#search").val($(e.currentTarget).val())
        }
    });

    $(".js-close-search-modal").on("click", function (e) {
        e.preventDefault();
        $("#search-modal").slideUp();
        $body.removeClass("modal-open");
    });

    // Report a comment
    $(document).on("click", ".js-report-comment", function (e) {
        var id = $(e.target).data("id");
        $(e.target).val("Vänta...");
        let undo = ($(e.target).attr('data-undo') === 'true');
        axios.post("/comment/report" , {
            undo: undo,
            id: id
        }).then(function (response) {
            $(e.target).attr('data-undo',!undo );
            $(e.target).html(undo ?  "Rapportera" : "Ångra Rapport");
        });
    });

    $(document).on('click', ".js-reply-comment", function (e) {
        var id = $(e.target).data('id');
        $(`.reply-form-${id}`).slideToggle('d-none')
    })

    $(document).on('click', '.toggle-more-comment', (e) => {
        $(`.toggle-comment-${$(e.target).attr('data-related-id')}`).removeClass('comment-clamped-text');
        $(e.target).hide();
    })

    $(document).on('click', '.toggle-child-comment', (e) => {
        const comment = $(e.currentTarget).data('id');
        $(`.children-${comment}`).slideToggle();
        // will toggle the child comments also
        checkAndToggleChildComments($(`.children-${comment}`));
    })

    function checkAndToggleChildComments(comment) {
        $(comment).each(function () {
            const comment = $(this).attr('id');
            const childComment = $(`.children-${comment}`);
            setTimeout(function () {
                childComment.slideToggle();
                checkAndToggleChildComments(childComment);
            }, 500);
        })
    }

    $(".js-report-reply").on("click", function (e) {
        $("#report-form-reply-" + $(e.target).data("id")).toggle();
    });

    $(".js-delete-reply").on("click", function (e) {
        $("#delete-form-reply-" + $(e.target).data("id")).toggle();
    });

    $(".js-report-topic").on("click", function (e) {
        $("#report-form-topic-" + $(e.target).data("id")).toggle();
    });

    $(".js-delete-topic").on("click", function (e) {
        $("#delete-form-topic-" + $(e.target).data("id")).toggle();
    });

    $(".js-quote-text").on("click", function (e) {
        var target = $("#" + $(e.target).data("id"));
        var textToQuote = target.find(".js-text-to-quote").text();
        var $topicReplyForm = $("#ckeditor1");

        CKEDITOR.instances.ckeditor1.setData(textToQuote);

        $('html, body').animate({
            scrollTop: $(".reply-detail-form").offset().top - 100
        }, 500, function () {
            // $topicReplyForm.focus();
            // $topicReplyForm.prop('selectionStart', $topicReplyForm.val().length);
            // $topicReplyForm.prop('selectionEnd', $topicReplyForm.val().length);
            // $topicReplyForm.prop('scrollTop', $topicReplyForm.scrollHeight);
        });

    })

    $(".forumtopic-toggle-subscribe").on("click", function () {
        var e = $(this);
        if ($(e).hasClass("subscribed")) {
            $.get(window.location.href + "/unsubscribe", function () {
                $(e).html("<img src=\"" + subscribeImage + "\"> Prenumerera").removeClass("subscribed");
            });
        } else {
            $.get(window.location.href + "/subscribe", function () {
                $(e).html("<img src=\"" + subscribeImage + "\"> Avprenumerera").addClass("subscribed");
            });
        }
    });

    // Making solid the thumbs-up icon of comment .
    $(".like-button.likes").find("i").replaceWith("<i class='fas fa-thumbs-up text-primary'></i>");

    // Event for remove 'like' .
    $(document).on("click", ".like-button.likes", commentRemoveLike);

    // Event for like on comment .
    $(document).on("click", ".like-button:not(.likes):not(.mine)", commentLike);

    // Forum topic and reply like action.
    $(".like-button-topic, .like-button-reply").on("click", function () {
        return handleLike($(this), $(this).hasClass("likes") ? "remove-like" : "like");
    });

    $(".subscribe-js").on("click", function () {
        var e = $(this);
        var data = {"id": e.data("id"), "type": e.data("type")};

        if ($(e).hasClass("subscribed")) {
            $.post("/unsubscribe", data, function () {
                e.removeClass("subscribed");
                uiToggle(e);
            });
        } else {
            $.post("/subscribe", data, function () {
                e.addClass("subscribed");
                uiToggle(e);
            });
        }

        function uiToggle(e) {
            if (e.hasClass("icon")) {
                e.hasClass("subscribed") ?
                    e.removeClass("fa-plus").addClass("fa-minus")
                    : e.removeClass("fa-minus").addClass("fa-plus");
            } else {
                var newOther = e.html();
                e.html(e.data("other_text"));
                e.data("other_text", newOther);
            }
        }
    });

    $(".connect-js").on("click", function () {
        var e = $(this);
        var data = {"id": e.data("user_id")};
        $.get("/api/connect/" + data.id, data, function () {
            if ($(e).hasClass("connected")) {
                e.removeClass("connected");
            } else {
                e.addClass("connected");
            }
                uiToggle(e);
        });

        function uiToggle() {
            var newOther = e.html();
            e.html(e.data("other_text"));
            e.data("other_text", newOther);
        }

    });

    $(".js-category-subscribe").on("click", function () {
        var e = $(this);
        if ($(e).hasClass("subscribed")) {
            $.post(window.location.href + "/unsubscribe", {}, function () {
                e.html("<img src=\"" + subscribeImage + "\"> Prenumerera").removeClass("subscribed");
            });
        } else {
            $.post(window.location.href + "/subscribe", {}, function () {
                e.html("<img src=\"" + subscribeImage + "\"> Avprenumerera").addClass("subscribed");
            });
        }
    });

    $('.presentation-slide').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        arrows: true
    });

    $document.on('click', '.lightbox', function (event) {
        event.preventDefault();
        var $this = $(this);

        if ($this.parent().prop("nodeName").toLowerCase() !== "a") {
            $this.wrap("<a href='" + $this.prop("src") + "' title='" + $this.prop("alt") + "'></a>");
        }

    });

    $(".js-connected-show").on("click", function (event) {
        event.preventDefault();
        $(".js-connected-wrap").slideToggle();
        $(".js-profile-other").slideToggle();
    });

    $(".js-category-dropdown-toggle, .js-category-dropdown-current").on("click", function () {
        const $categoryDropdown = $(this).closest(".category-dropdown");
        const $categoryDropdownUl = $categoryDropdown.find("ul");

        $categoryDropdown.toggleClass("open");

        let open = $categoryDropdown.hasClass("open");

        $categoryDropdown.find(".category:not(.current)").each(function (index, category) {
            setTimeout(function () {
                open ? $(category).show() : $(category).hide();
            }, index * 16);
        });
    });

    $(".js-thankyou").on("click", function (e) {
        var elem = $(this);
        elem.html("Skickar").attr("disabled", "disabled");
        axios.post('/forum/thankyou', {
            post: $(this).data("reply")
        }).then(function (response) {
            elem.removeClass(".js-thankyou").unbind("click").html("Tack");
        })
    });


    $.fn.setCursorPosition = function (pos) {
        this.each(function (index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };

    // From: https://stackoverflow.com/a/3809435
    function regexMatchUrl(string) {
        var expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
        var regex = new RegExp(expression);
        return string.match(regex)
    }

    // Removed for now, url pasting feature disabled for now.
    // $("textarea.bbcode").on("paste", function (e) {
    //     var paste = (e.originalEvent.clipboardData || window.clipboardData).getData('text')
    //     var $this = $(this)
    //
    //     if (regexMatchUrl(paste)) {
    //         e.preventDefault();
    //
    //         var selection = window.getSelection()
    //
    //         if (!selection.rangeCount) return false;
    //
    //         var start = $this.get(0).selectionStart;
    //         var end = $this.get(0).selectionEnd;
    //         var val = $this.val()
    //
    //         var before = '[url]' + paste + '[/url]'
    //         var after = ''
    //
    //         var new_string = insertBetweenText(start, end, val, before, after);
    //
    //         $this.val(new_string).focus().setCursorPosition(end + before.length + after.length);
    //     }
    // });

    $(".bbcode .insert").on("click", function () {
        var input = $(this).parent().parent().parent().parent().find("textarea").first();
        var start = $(input).get(0).selectionStart;
        var end = $(input).get(0).selectionEnd;
        var before = $(this).data("before");
        var after = $(this).data("after");
        var val = input.val();
        var new_string = insertBetweenText(start, end, val, before, after);

        input.val(new_string).focus().setCursorPosition(end + before.length + after.length);
    });

    import("popper.js").then(function (popper) {
        window.Popper = popper.default;
        $('[data-toggle="tooltip"]').tooltip();
    });

    let {getDeviceType} = require("./get-device-type")
    $body.addClass("device-" + getDeviceType().toLowerCase());

    import('select2').then(function () {
        $("#userarea, #usersector").select2();

        $('#area').select2({
            placeholder: 'Välj område'
        });

        $(".dropdown-parent select").select2({
            dropdownParent: $(".dropdown-parent"),
            searchInputPlaceholder: 'Search',
            allowClear: true
        }).on("change", function (event) {
            axios.post('/areas', {area: event.target.value}).then(response => {
                if (response.data.location) {
                    location.href = response.data.location
                }
            })
        })

        $(".dropdown-parent button").on("click", function () {
            $(".dropdown-parent select").select2("open")
        })
    });


    if ($body.hasClass("login-open")) {
        if (!slickInited) {
            $('.slick').slick({
                autoplaySpeed: 3000,
                dots: true
            });
            slickInited = true
        }
    }

    $(".js-scroll-document").on("click", function () {
        $('html, body').animate({
            scrollTop: ($(".sidebar-inner > .block.document").offset().top - 100)
        }, 500, function () {
            $(".sidebar-inner > .block.document").addClass("pulse");
        });
    });

    $(".js-scroll-product").on("click", function () {
        $('html, body').animate({
            scrollTop: ($(".sidebar-inner > .block.product").offset().top - 100)
        }, 500, function () {
            $(".sidebar-inner > .block.product").addClass("pulse");
        });
    });

    $(document).on('submit', '.productpurchaseform', function (e) {
        e.preventDefault()

        $(this).find(".js-productpurchaseform-error").slideUp()

        axios.post($(this).prop('action'), $(this).serialize()).then(function (response) {

            if (response.data.type === 'stripe') {
                var stripe = Stripe(response.data.public_key)

                stripe.redirectToCheckout({
                    // Make the id field from the Checkout Session creation API response
                    // available to this file, so you can provide it as parameter here
                    // instead of the {{-- CHECKOUT_SESSION_ID --}} placeholder.
                    sessionId: response.data.session_id
                }).then(function (result) {
                    $(".js-productpurchaseform-error").text(result.error.message).slideDown()
                    // If `redirectToCheckout` fails due to a browser or network
                    // error, display the localized error message to your customer
                    // using `result.error.message`.
                })
            } else if (response.data.type === 'payer') {
                if (response.data.success) {
                    window.location.href = response.data.redirect_url
                } else {
                    $(".js-productpurchaseform-error").text(response.data.error_msg).slideDown()
                }
            }

        }).catch(function (error) {
            var message = ''
            if (error.response.data) {
                if (error.response.data.errors) {
                    var keys = Object.keys(error.response.data.errors)
                    keys.forEach(function (key) {
                        message += error.response.data.errors[key]
                    })
                } else {
                    message = error.response.data.message
                }
            } else {
                message = error.message
            }
            $(".js-productpurchaseform-error").text(message).slideDown()
        })
    })

    $(".js-productpurchaseform-button").prop("disabled", false);

    $(".documentpurchaseform").on("submit", function (e) {
        e.preventDefault()

        $(this).find(".js-documentpurchaseform-error").slideUp()

        axios.post($(this).prop('action'), $(this).serialize()).then(function (response) {

            if (response.data.type === 'stripe') {
                var stripe = Stripe(response.data.public_key)

                stripe.redirectToCheckout({
                    // Make the id field from the Checkout Session creation API response
                    // available to this file, so you can provide it as parameter here
                    // instead of the {{-- CHECKOUT_SESSION_ID --}} placeholder.
                    sessionId: response.data.session_id
                }).then(function (result) {
                    $(".js-documentpurchaseform-error").text(result.error.message).slideDown()
                    // If `redirectToCheckout` fails due to a browser or network
                    // error, display the localized error message to your customer
                    // using `result.error.message`.
                })
            } else if (response.data.type === 'payer') {
                if (response.data.success) {
                    window.location.href = response.data.redirect_url
                } else {
                    $(".js-documentpurchaseform-error").text(response.data.error_msg).slideDown()
                }
            }

        }).catch(function (error) {
            var message = ''
            if (error.response.data) {
                if (error.response.data.errors) {
                    var keys = Object.keys(error.response.data.errors)
                    keys.forEach(function (key) {
                        message += error.response.data.errors[key]
                    })
                } else {
                    message = error.response.data.message
                }
            } else {
                message = error.message
            }
            $(".js-documentpurchaseform-error").text(message).slideDown()
        })
    })

    checkCompact();
    $("#compact-mode").on("change", () => checkCompact());

    if (window.location.pathname == '/') {


        $.ajax({
            method: 'get',
            url: '/aktiva-medlemmar'
        }).then(function (response) {
            $(".active-users").append(response);
        });
    }

    $('.documentpurchaseformpayson .js-documentpurchaseform-button').on('click', (e) => {
        if ($(".documentpurchaseformpayson input[name='email']").val() == ""){
            $(".js-documentpurchaseform-error").attr("style","display:block;").html("Du måste fylla i en e-postadress");
            $("#checkoutModal .checkout-modal-body")
                .html("Du måste fylla i en e-postadress")
                .attr("style","text-align:center;padding:1rem;color:crimson;");
        } else {
            $("#checkoutModal .checkout-modal-body")
                .html("");
            $.ajax({
                method: 'get',
                url: '/document-checkout-modal/'
                    +$(e.currentTarget).data('document_id')
                    +'/'+
                    $('input[name="variant"]:checked').val()
                    +'/'+
                    $(".documentpurchaseformpayson input[name=\'email\']").val(),
                beforeSend : function () {
                    $("#checkoutModal .checkout-modal-body")
                        .html("<div class='d-flex justify-content-center py-2'><i class='spinner-border text-secondary'></i></div>");
                }
                ,success: function (response) {
                    $("#checkoutModal .checkout-modal-body")
                        .html(response);
                },statusCode: {
                    400: function (response) {
                        $("#checkoutModal .checkout-modal-body")
                            .html(response.responseJSON.message)
                            .attr("style","text-align:center;padding:1rem;color:crimson;");
                    }
                }
            });
        }
    })

    $('.productpurchaseformpayson .js-productpurchaseform-button').on('click', (e) => {
        e.preventDefault();
        if ($(".productpurchaseformpayson input[name='email']").val() == ""){
            $(".js-productpurchaseform-error").attr("style","display:block;").html("Du måste fylla i en e-postadress");
            $("#checkoutModal .checkout-modal-body")
                .html("Du måste fylla i en e-postadress")
                .attr("style","text-align:center;padding:1rem;color:crimson;");
        } else {
            $("#checkoutModal .checkout-modal-body")
                .html("");
            $.ajax({
                method: 'get',
                url: '/product-checkout-modal/'
                    +'?product_id='
                    +$("input[name=\'product_id\']").val()
                    +'&quantity='+
                    $('select[name="quantity"]').val()
                    +'&email='+
                    $(".productpurchaseformpayson input[name=\'email\']").val(),
                beforeSend : function () {
                    $("#checkoutModal .checkout-modal-body")
                        .html("<div class='d-flex justify-content-center py-2'><i class='spinner-border text-secondary'></i></div>");
                }
                ,success: function (response) {
                    $("#checkoutModal .checkout-modal-body")
                        .html(response);
                },statusCode: {
                    400: function (response) {
                        $("#checkoutModal .checkout-modal-body")
                            .html(response.responseJSON.message)
                            .attr("style","text-align:center;padding:1rem;color:crimson;");
                    }
                }
            });
        }
    });

    // Controling is user clicked custom ad and redirecting
    if ($(".js-logged-in").length && getCookie("comes-from-offer") && window.location.pathname != "/erbjudanden/4") {
        window.location.pathname="/erbjudanden/4";
    }
    deleteCookie("comes-from-offer");

    // Article link copy to clipboard
    $(".js-copy-link").on("click", function (e) {
        e.preventDefault();
        const fullUrl = $(this).data('link');
        navigator.clipboard.writeText(fullUrl);
        $(`.toast${$(this).data('index')}`).toast('show');
    });

});

// Setting a cookie for custom ad on sidebar
$("body").on("click", ".js-banner-offer", () => {
    setCookie("comes-from-offer","true",1);
});

const checkCompact = () => {
    const article = $('.small-article');
    const checked = $('#compact-mode').is(':checked')

    setCookie('compactMode', checked, 7)

    checked
        ? article.addClass('compact-article')
        : article.removeClass('compact-article')
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    const nameEQ = cname + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0)===' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function deleteCookie(cname) {
    document.cookie = cname +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


$(window).on("load", function () {
    var tag = document.createElement("script");
    tag.src = "https://www.google.com/recaptcha/api.js";
    document.getElementsByTagName("head")[0].appendChild(tag);
});

window.onload = setTimeout(function (){
    let locationFinderHidden = false
    if ($('#ASRM_MOAT').length){
        $('.header-container-placeholder,#header-container').attr('style','position:sticky');
    }else {
        $(window).on("scroll", function () {
            if (window.scrollY > 53) {
                if (!locationFinderHidden) {
                    if (window.matchMedia("(min-width: 769px)").matches) {
                        $(".js-header-location-finder").slideUp();
                        $("#menu-row #logo").toggleClass('d-none d-flex');
                        $('#menu-row ul li').toggleClass('slided-down')
                    } else {
                        $('.mobile-scroll-hide').toggleClass('d-none d-flex')
                    }
                    locationFinderHidden = true
                }
                $('.toggle-slide-user-info').removeClass('d-none');
            } else {
                if (locationFinderHidden) {
                    if (window.matchMedia("(min-width: 769px)").matches) {
                        $(".js-header-location-finder").slideDown();
                        $("#menu-row #logo").toggleClass('d-none d-flex');
                        $('#menu-row ul li').toggleClass('slided-down');
                    } else {
                        $('.mobile-scroll-hide').toggleClass('d-none d-flex')
                    }
                    locationFinderHidden = false
                }
                $('.toggle-slide-user-info').addClass('d-none');
            }
        })
    }
},3000);

$(document).on('click', '.login-register-change', function () {
    $('.login-area, .register-area').toggleClass('d-none d-flex');
    $('.login-register-area').toggleClass('flex-row-reverse')
})

$('#login-modal').on('click', (el) => {
    if ($(el.target).attr('id') === 'login-modal') {
        $('#login-modal').slideToggle()
    }
})

// element variable is the element of the like button
// event variable is the `like` or `remove-like` event
function handleLike (element, event) {
    var e = $(element);
    $.get(`/${event}/${e.data('type')}/${e.data('id')}`, function () {
        // changing icon and data-count of the like button element
        if (event === "like") {
            e.addClass('likes').find("span").html((e.data("count") + 1) + " <i class='ml-1 fas fa-thumbs-up'></i>");
            e.data("count", e.data("count") + 1);
        } else if (event === "remove-like") {
            e.removeClass('likes').find("span").html((e.data("count") - 1) + " <i class='ml-1 far fa-thumbs-up'></i>");
            e.data("count", e.data("count") - 1);
        }
    });
}

function commentLike (event) {
    var e = $(this);
    e.addClass('likes');
    $.get("/like/" + e.data("type") + "/" + e.data("id"), function () {
        e.find("i").replaceWith("<i class='fas fa-thumbs-up text-primary'></i>");
        const likeCount = $(`.like-count[data-id='${e.data("id")}']`);
        // if like count element exists increase it
        if (likeCount.length) {
            likeCount.html(parseInt(likeCount.html())+1);
        }
    });
}

function commentRemoveLike (event) {
    var e = $(this);
    e.removeClass('likes');
    $.get("/remove-like/" + e.data("type") + "/" + e.data("id"), function () {
        e.find("i").replaceWith("<i class='far fa-thumbs-up text-primary'></i>");
        const likeCount = $(`.like-count[data-id='${e.data("id")}']`);
        // if like count element exists decrease it
        if (likeCount.length) {
            likeCount.html(parseInt(likeCount.html())-1);
        }
    });
}

function insertBetweenText(start, end, str, text1, text2) {
    return str.substring(0, start) + text1 + str.substring(start, end) + text2 + str.substring(end);
}

$(document).on("click", ".insert-comment", function () {
    var article = $(this).data("comment_for")
    var input = $(`textarea[data-article="${article}"]`);
    var start = $(input).get(0).selectionStart;
    var end = $(input).get(0).selectionEnd;
    var before = $(this).data("before");
    var after = $(this).data("after");
    var val = input.val();
    var new_string = insertBetweenText(start, end, val, before, after);

    input.val(new_string).focus().setCursorPosition(end + before.length + after.length);
});

$(document).on('click', '.update-view', (e) => {
    var id = $(e.currentTarget).data('id');
    $.ajax({
        url: '/update-view-count',
        data: {
            'id': id
        },
        type: 'post'
    })
})

$('.js-delete-user').on('click', function (e) {
    $("#delete-user-" + $(e.target).data("id")).toggle();
});